import request from '@/utils/request'
const baseUrl = '/sys'
export default {
	/**
	 * 列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	dataList( params={} ) {
		return request({
	    url: baseUrl + '/charging/pile/list',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 添加
	**/
	dataAdd(data){
		return request({
			url: baseUrl + '/charging/pile/create',
			method:'POST',
			data
		})
	},

	/**
	 * 编辑
	**/
	dataEdit(data){
		return request({
			url: baseUrl + '/charging/pile/update',
			method:'POST',
			data
		})
	},
	/**
	 * 删除
	**/	
	dataDel(id){
		return request({
			url: baseUrl + '/charging/pile/delete',
			method:'POST',
			data: {
				id
			}
		})
	},

	/**
	 * 订单列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	orderList( params={} ) {
		return request({
	    url: baseUrl + '/charging/order/list',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 远程启动
	**/
	remoteStart( data ) {
		return request({
	    url: baseUrl + '/charging/start/remote',
	    method:'POST',
		data
	  })
	},

	/**
	 * 远程停止
	**/
	remoteStop( data ) {
		return request({
	    url: baseUrl + '/charging/stop/remote',
	    method:'POST',
		data
	  })
	}
}